export default __webpack_public_path__ + "static/publico-9c0d11fa1654e46e199c1821fd7faaf7.jpg";